import React from "react";
import { Box, Zoom, Fab, useScrollTrigger } from "@material-ui/core";
import {
  WhatsApp as WhatsAppIcon
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import LinkEcco from "../Link";
import TagManager from 'react-gtm-module';

const useStyles = makeStyles( theme => ({
    root: {
        bottom: theme.spacing(["5", 10]),
        [theme.breakpoints.up("xs")]: {
          position: "fixed",
          right: `65px`,
        },
        [theme.breakpoints.down("xs")]: {
          position: "fixed",
          right: `65px`,
          maxWidth: 340
        },
        zIndex: 1001
      },
    addButton: {
      backgroundColor: "#25d366",
      "&:hover": {
        backgroundColor: "#21bd5c"
      }
    },
    addButtonIcon: {
        marginTop: "5px",
        color: "white",
    }
  }));

const FloatingWhatsappButton = ({ home = false, isNotes = false, isSocios = false}) => {
  const classes = useStyles();
  const scrollTrigger = useScrollTrigger({
    // disableHysteresis: true,
    threshold: 100
  });

  return (
    <div>
      {isSocios ? (
        <Zoom in={scrollTrigger} style={{marginRight: 80}}>
          <Box className={classes.root}>
          
              <Fab className={classes.addButton} elevation={0}>
              <LinkEcco
                  external={true}
                  url={window.location.hostname === "www.ecco.com.ar" ? "https://api.whatsapp.com/send?phone=541144499787&text=¡Hola!%20Quiero%20realizar%20una%20consulta." : "https://api.whatsapp.com/send?phone=541149472125&text=¡Hola!%20Quiero%20realizar%20una%20consulta."}
                  href={window.location.hostname === "www.ecco.com.ar" ? "https://api.whatsapp.com/send?phone=541144499787&text=¡Hola!%20Quiero%20realizar%20una%20consulta." : "https://api.whatsapp.com/send?phone=541149472125&text=¡Hola!%20Quiero%20realizar%20una%20consulta."}
                  target="_blank"
                  onClick={()=> {
                    TagManager.dataLayer({
                      dataLayer: {
                        event: "WAIniciaChat",
                        pageURL: window.location.href
                      },
                    })
                  }}
                >
                  <WhatsAppIcon className={classes.addButtonIcon} fontSize="large" />
                </LinkEcco>
                
              </Fab>
          </Box>
        </Zoom>
      ):(
          <Box className={classes.root}>
          
              <Fab className={classes.addButton} elevation={0}>
              <LinkEcco
                  external={true}
                  url={window.location.hostname === "www.ecco.com.ar" ? "https://api.whatsapp.com/send?phone=541144499787&text=¡Hola!%20Quiero%20realizar%20una%20consulta." : "https://api.whatsapp.com/send?phone=541149472125&text=¡Hola!%20Quiero%20realizar%20una%20consulta."}
                  href={window.location.hostname === "www.ecco.com.ar" ? "https://api.whatsapp.com/send?phone=541144499787&text=¡Hola!%20Quiero%20realizar%20una%20consulta." : "https://api.whatsapp.com/send?phone=541149472125&text=¡Hola!%20Quiero%20realizar%20una%20consulta."}
                  target="_blank"
                  onClick={()=> {
                    TagManager.dataLayer({
                      dataLayer: {
                        event: "WAIniciaChat",
                        pageURL: window.location.href
                      },
                    })
                  }}
                >
                  <WhatsAppIcon className={classes.addButtonIcon} fontSize="large" />
                </LinkEcco>
                
              </Fab>
          </Box>
      )}
      
    </div>
  );
};

export default FloatingWhatsappButton;
